import productsReducers from "./productsReducers";

const receiveProducts = (
  state,
  { error, payload: { products, itemCount } = {} }
) => {
  if (error) {
    return state;
  }

  const isDisplayed = itemCount !== 0;

  return {
    ...productsReducers.reduce(
      (state, reducer) => reducer(state, products),
      state
    ),
    isDisplayed
  };
};

export default receiveProducts;
